import { config } from '@web/config/env';
import { useIsStandalone } from '@web/intacct/build-type';
import { useLocation } from 'react-router';
import { useJoinUsLocalStorage } from './join-us-storage';
import { JoinUsDialogContent } from './JoinUsDialogContent';

export default function JoinUsDialog() {
  const { date, setJoinUsDate } = useJoinUsLocalStorage();
  const isStandalone = useIsStandalone();
  const { pathname } = useLocation();
  const isJoinUsDialogVisible = !(pathname.includes('external-auth') || pathname.includes('privacy') || pathname.includes('deep-linking'));
  const open = config.joinUsModalEnabled && (!date || date <= new Date()) && isStandalone && isJoinUsDialogVisible;
  // The external auth page will set the build type

  return (
    <JoinUsDialogContent
      open={open}
      onOk={() => {
        setJoinUsDate(1);
      }}
      onRemindMeLater={() => {
        setJoinUsDate(1);
      }}
    />
  );
}
